import { Stack } from '@ace-clublabs/shared-component-library';
import { UpgradeBenefitIWT, AddFamilyMembersIWT } from './IWTs';
import { ManageMembershipIWT } from './IWTs/ManageMembershipIWT';
import { useGlobalState } from '../../state/state';
import { MembershipCardIWT } from './IWTs/MembershipCardIWT';
import { ClubCode } from '../../utils/constants';
import { RoleType } from '@ace-clublabs/common-membership-api-types';

export const MembersDetailsActionButtons = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const [isMobileApp] = useGlobalState('isMobileApp');
  const canChangeMembership = memberDetails?.loggedInMember?.rules?.changeMembership;

  return (
    <Stack
      className="members-details-action-section"
      id="members-details-action-buttons"
      direction={'row'}
      flexWrap="nowrap"
      sx={{
        margin: '0.5rem 0rem 1rem -1rem',
        padding: '0 1rem',
        overflow: 'scroll',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      {canChangeMembership ? (
        <>
          <AddFamilyMembersIWT />
          <ManageMembershipIWT />
          <UpgradeBenefitIWT />
        </>
      ) : (
        <></>
      )}
      <MembershipCardIWT />
    </Stack>
  );
};
